import * as queries from '@supabase/queries';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";

export default function useEditProject() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.project._def,
        mutationFn: queries.editProject,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: queryKeys.project._def, exact: false});
        }
    });
}